<template>
  <FlyModal
    :header-box-props="_headerBoxProps"
    :footer-box-props="_footerBoxProps"
    @close="onModalClose"
  >
    <template #header>
      <FlyText v-bind="{ ...TEXT_VARIANTS_ENUM.H3, ...titleTextProps }">
        <slot name="title">{{ title }}</slot>
      </FlyText>
      <FlyButton
        type="button"
        :style="{ position: 'absolute', right: '16px', top: '16px' }"
        v-bind="BUTTON_VARIANTS_ENUM.ICON"
        @click="onCloseClick"
      >
        <FlyIcon name="Close" />
      </FlyButton>
    </template>
    <template #default>
      <slot></slot>
    </template>
    <template #footer>
      <FlyButton
        type="button"
        margin-right="4"
        v-bind="{ ...BUTTON_VARIANTS_ENUM.TERTIARY, ...cancelBtnProps }"
        @click="onCancelClick"
      >
        <slot name="cancelBtnText">{{ cancelBtnText }}</slot>
      </FlyButton>
      <FlyButton
        type="button"
        v-bind="{ ...BUTTON_VARIANTS_ENUM.PRIMARY, ...okBtnProps }"
        @click="onConfirm"
      >
        <slot name="okBtnText">{{ okBtnText }}</slot>
      </FlyButton>
    </template>
  </FlyModal>
</template>

<script>
import VueTypes from 'vue-types';
import FlyModal from 'shared/components/Modal/FlyModal';
import FlyText from 'shared/components/Text/FlyText';
import FlyButton from 'shared/components/Button/FlyButton';
import BORDER_STYLE_ENUM from 'shared/components/Border/BORDER_STYLE_ENUM';
import BORDER_WIDTH_ENUM from 'shared/components/Border/BORDER_WIDTH_ENUM';
import COLOR_ENUM from 'shared/components/Color/COLOR_ENUM';
import deepmerge from 'deepmerge';
import FlyIcon from 'shared/components/Icon/FlyIcon';
import POSITION_ENUM from 'shared/components/Grid/POSITION_ENUM';

export default {
  name: 'FlyConfirmationModal',
  components: { FlyIcon, FlyButton, FlyText, FlyModal },
  props: {
    titleTextProps: VueTypes.object.def({}),
    title: VueTypes.string.def(''),
    cancelBtnProps: VueTypes.object.def({}),
    cancelBtnText: VueTypes.string.def('Cancel'),
    okBtnProps: VueTypes.object.def({}),
    okBtnText: VueTypes.string.def('Save'),
    headerBoxProps: VueTypes.object.def({}),
    footerBoxProps: VueTypes.object.def({}),
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      defaultHeaderBoxProps: {
        paddingLeft: '6',
        paddingRight: '15',
        style: { paddingTop: '18px', paddingBottom: '18px' },
        noShrink: true,
        position: POSITION_ENUM.RELATIVE,
        width: 'full',
      },
      defaultFooterBoxProps: {
        paddingVertical: '4',
        paddingHorizontal: '5',
        borderStyleTop: BORDER_STYLE_ENUM.SOLID,
        borderWidthTop: BORDER_WIDTH_ENUM['1'],
        borderColorTop: COLOR_ENUM.GREY_7,
        flexJustify: 'end',
      },
    };
  },
  computed: {
    _headerBoxProps() {
      return deepmerge(this.defaultHeaderBoxProps, this.headerBoxProps);
    },
    _footerBoxProps() {
      return deepmerge(this.defaultFooterBoxProps, this.footerBoxProps);
    },
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    onCloseClick() {
      this.emitClose();
    },
    onCancelClick() {
      this.emitClose();
    },
    onModalClose() {
      this.emitClose();
    },
    onConfirm() {
      this.$emit('confirm');
      this.emitClose();
    },
  },
};
</script>

<style lang="scss"></style>
